// extracted by mini-css-extract-plugin
module.exports = {"upgrade":"_s","upgradeHide":"_t"};